<template>
  <vue-final-modal v-model="showModal" classes="modal-container" content-class="modal-content-f w800">
    <div class="m-head p-3">
      <a class="close" href="#" @click.prevent="close">
        <span class="material-icons-outlined">close</span>
      </a>
      <h4>Historie kreditů lekce</h4>
    </div>
    
    <div class="m-body p-3">
      <div v-if="loading" class="text-center py-4">
        <div class="spinner-border" role="status">
          <span class="sr-only">Načítání...</span>
        </div>
      </div>
      
      <div v-else-if="lessonData">
        <!-- Lesson info box -->
        <div class="alert alert-info mb-3">
          <div class="row">
            <div class="col-md-6">
              <strong>Studenti:</strong><br>
              <div v-for="student in lessonData.students" :key="student.id">
                {{ student.name }} <small class="text-muted">({{ student.email }})</small>
              </div>
            </div>
            <div class="col-md-6">
              <strong>Lektor:</strong> {{ lessonData.lector_name || '-' }}<br>
              <strong>Typ lekce:</strong> {{ lessonData.lesson_type_name }}<br>
              <strong>Minutáž:</strong> {{ lessonData.minutes }} min<br>
              <strong>Aktuální kredit:</strong> 
              <span class="badge bg-primary">{{ lessonData.current_credit }} lekcí</span>
            </div>
          </div>
          <div v-if="lessonData.organization_name" class="mt-2">
            <strong>Organizace:</strong> {{ lessonData.organization_name }}
          </div>
        </div>
        
        <!-- Credit history table -->
        <h5>Historie změn:</h5>
        <div v-if="lessonData.credit_transfers.length === 0" class="alert alert-warning">
          Zatím nejsou žádné záznamy o kreditech.
        </div>
        <table v-else class="table table-striped table-bordered">
          <thead>
            <tr>
              <th>Datum a čas</th>
              <th>Typ operace</th>
              <th>Objednávka</th>
              <th>Množství</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="transfer in lessonData.credit_transfers" :key="transfer.id">
              <td>{{ formatDate(transfer.created_at) }}</td>
              <td>
                <span :class="getCreditTypeClass(transfer.kind)">
                  {{ getCreditTypeLabel(transfer.kind) }}
                </span>
              </td>
              <td>
                <a v-if="transfer.order_id" :href="'/orders/' + transfer.order_id" target="_blank">
                  {{ transfer.order_number }}
                </a>
                <span v-else>-</span>
              </td>
              <td :class="transfer.amount > 0 ? 'text-success fw-bold' : 'text-danger fw-bold'">
                {{ transfer.amount > 0 ? '+' : '' }}{{ transfer.amount }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      
      <div v-else class="alert alert-danger">
        Nepodařilo se načíst data lekce.
      </div>
    </div>
  </vue-final-modal>
</template>

<script>
import { VueFinalModal } from "vue-final-modal";
import axios from "axios";

export default {
  name: "admin-credit-history-modal",
  components: { VueFinalModal },
  data() {
    return {
      showModal: false,
      loading: false,
      lessonData: null
    };
  },
  methods: {
    async open(lessonId) {
      this.showModal = true;
      this.loading = true;
      this.lessonData = null;
      
      try {
        const response = await axios.get(`/ll/students/lessons/${lessonId}/credit_history.json`);
        this.lessonData = response.data;
      } catch (error) {
        console.error('Error loading credit history:', error);
        alert('Chyba při načítání historie kreditů. Zkuste to prosím znovu.');
      } finally {
        this.loading = false;
      }
    },
    close() {
      this.showModal = false;
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString('cs-CZ', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      });
    },
    getCreditTypeLabel(kind) {
      const labels = {
        initial_credit: 'Počáteční nákup',
        update_vyuka: 'Úprava',
        lesson_realized: 'Lekce realizována',
        correction: 'Korekce',
        eshop_order: 'Nákup z e-shopu',
        eshop_refund: 'Vratka z e-shopu'
      };
      return labels[kind] || kind;
    },
    getCreditTypeClass(kind) {
      const classes = {
        initial_credit: 'badge bg-success',
        update_vyuka: 'badge bg-info',
        lesson_realized: 'badge bg-warning',
        correction: 'badge bg-secondary',
        eshop_order: 'badge bg-success',
        eshop_refund: 'badge bg-danger'
      };
      return classes[kind] || 'badge bg-light';
    }
  }
};
</script>

<style scoped>
.w800 {
  max-width: 800px;
  width: 90%;
}

.table {
  font-size: 14px;
}

.table th {
  background-color: #f8f9fa;
  font-weight: 600;
}

.badge {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
}

.fw-bold {
  font-weight: 600;
}
</style>
